import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config";
import Header from "../../Header";
import Footer from "../../Pages/Footer";
import Connectwallet from "../Login/Connect_wallet";
import Google from "../../Pages/Presale/IconBox/Google";
import Thanks from "../Login/Thanks";
// import Selectmethod from "./Selectmethod";
import Qrcode from "../Login/Qrcode";
import "../../Pages/css/login.css";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import * as ACTIONTYPES from "../../../redux/actionTypes";
import * as Yup from "yup";
import { Formik } from "formik";
import { Spin } from "antd";
import { ERROR, Success, Warning } from "../../../utils/errors";
import { forgetPassword, userlogin } from "../../../services/apiServices";
import { useDispatch } from "react-redux";
import { FaRegEye } from "react-icons/fa";
import { useSelector } from "react-redux";

const LoadingPopup = () => {
  return (
    <div className="loading-popup-container">
      <div className="loading-popup">
        <p>Please wait</p>
        <h1>Loggin in . . .</h1>
      </div>
    </div>
  );
};

const Changepassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmpassword, setconfirmPassword] = useState("");
  const [otp, setotp] = useState("");

  const forgetEmails = useSelector((state) => state.auth.ForgetEmail);

  const [showpass, setshowpass] = useState(false);

  useEffect(() => {
    if (!forgetEmails) {
      navigate(`${config.baseurl}login`);
    }
  }, []);

  const submitForm = async (values) => {
    // alert(1);
    if (password != confirmpassword) {
      setShowLoading(false);
      Warning("Password do not match");
      return;
    }
    if (!password || !confirmpassword || !otp) {
        setShowLoading(false);
      Warning("Please enter required fields");
      return;
    }
    let res = await forgetPassword({
      emailAddress: forgetEmails,
      newPassword: password,
      confirmPassword: confirmpassword,
      otp: otp,
    });
    if (res.data.status) {
          navigate(`${config.baseurl}login`);
          Success("Password updated successfully");
      return;
    } else {
        Warning(res.data.message);
      return;
    }
  };

  const inputhandler = (e) => {
    if (e.target.name == "password") {
      setPassword(e.target.value);
    } else if (e.target.name == "confirmpassword") {
      setconfirmPassword(e.target.value);
    } else if (e.target.name == "otp") {
      setotp(e.target.value);
    }
  };

  const showPassword = (e) => {
    e.preventDefault();
    setshowpass(!showpass);
  };

  return (
    <>
      {/* <Header /> */}
      {/* <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setconnectWaaslletNow}
      /> */}
      <section className="login-section ">
        <div className="login-container">
          <Container fluid className="px-0">
            <Row className="justify-content-center">
              <Col lg={12}>
                <Row className="">
                  <Col lg={6} md={6} xs={12} className="">
                    <div className="login-form d-lg-block d-md-block d-none">
                      <div className="">
                        <img
                          src="assets/images/login/coinsbackImg.svg"
                          alt="logo"
                          className="coinsbackImg"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6} xs={12} className="">
                    <Spin spinning={showLoading}>
                      {/* <div className="loginDiv" style={{ minHeight: "368px" }}> */}
                      <div className="loginDiv pt-5">
                        <Row>
                          <Col lg={7} className="mx-auto">
                            <div className="form_content">
                              <div className="formDiv">
                                <div className="text-center formheadbox">
                                  <h1 className="text-primary fw-bold mb-1">
                                    Reset Paasword
                                  </h1>
                                  <p className="">
                                    <small>Enter new password </small>
                                  </p>
                                </div>
                                <div className="mb-3">
                                  <div className="input-field fieldbox px-0">
                                    <InputGroup className=" theme-input">
                                      <Form.Control
                                        type={`${
                                          showpass ? "name" : "password"
                                        }`}
                                        placeholder="New Password"
                                        aria-label="Password"
                                        aria-describedby="basic-addon1"
                                        onChange={inputhandler}
                                        name="password"
                                        className="py-2 "
                                      />
                                    </InputGroup>
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <div className="input-field fieldbox px-0">
                                    <InputGroup className=" theme-input">
                                      <Form.Control
                                        type={`${
                                          showpass ? "name" : "password"
                                        }`}
                                        placeholder="Confirm Password"
                                        aria-label="Password"
                                        aria-describedby="basic-addon1"
                                        name="confirmpassword"
                                        onChange={inputhandler}
                                        className="py-2 "
                                      />
                                    </InputGroup>
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <div className="input-field fieldbox px-0">
                                    <InputGroup className=" theme-input">
                                      <Form.Control
                                        type="name"
                                        placeholder="Enter OTP"
                                        aria-describedby="basic-addon1"
                                        name="otp"
                                        onChange={inputhandler}
                                        className="py-2 "
                                      />
                                    </InputGroup>
                                  </div>
                                </div>

                                <div className="text-center mt-3 ">
                                  <Button
                                    variant="custombtn2"
                                    className="py-2 w-100 fw-bold"
                                    type="button"
                                    onClick={submitForm}
                                  >
                                    Reset Paasword
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Spin>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* <Footer /> */}
      {isLoading && <LoadingPopup />}
    </>
  );
};

export default Changepassword;
